import AbstractController from "../../../../vendors/services/abstractController";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import ContribuinteService from "../../../services/contribuinte.service";
import ContribuinteModel from "../model/contribuinte.model";
import ToastService from "../../../../vendors/services/toastService";
import { Mensagem } from "../../../shared/mensagem/Mensagem";
import LoginService from "../../../services/LoginService";

export default class CompletarCadastroController extends AbstractController {
  public data: any;
  public setData: any;
  public idData: any;
  public setIdData: any;
  public empresaList: any;
  public setEmpresaList: any;
  public tipoInteressadoList: any;
  public setTipoInteressadoList: any;
  public areaInteresseList: any;
  public setAreaInteresseList: any;
  public ufList: any;
  public setUfList: any;
  public municipioList: any;
  public setMunicipioList: any;
  public model: ContribuinteModel;
  private service: ContribuinteService;
  private loginService: LoginService;

  constructor() {
    super();

    this.service = new ContribuinteService();
    this.loginService = new LoginService();
    this.model = new ContribuinteModel();
    [this.data, this.setData] = useState({});
    [this.idData, this.setIdData] = useState({});
    [this.empresaList, this.setEmpresaList] = useState([]);
    [this.tipoInteressadoList, this.setTipoInteressadoList] = useState([]);
    [this.areaInteresseList, this.setAreaInteresseList] = useState([]);
    [this.ufList, this.setUfList] = useState([]);
    [this.municipioList, this.setMunicipioList] = useState([]);
  }

  init() {
    const dados = this.location.state;
    const idToken: any = jwtDecode(dados.dadosLoginUnico.govBrIdToken);
    this.setData(dados);
    this.setIdData(idToken);
    this.setEmpresaList(dados.dadosLoginUnico.empresaList);
    this.obterTipoInteressado(dados.dadosLoginUnico);
    this.obterAreaInteresse();
    this.obterUf();
  }

  public salvar() {
    if (!this.validaSalvar()) {
      ToastService.showError(Mensagem.PREENCHA_TODOS_CAMPOS);
      return;
    }
    if (
      !this.model.rlContribuinteAreaInteresse ||
      this.model.rlContribuinteAreaInteresse.length <= 0
    ) {
      ToastService.showError("Nenhuma área de interesse selecionada.");
      return;
    }
    this.start();
    const obj: any = this.model;
    obj.dsEmail = this.idData.email;
    obj.noRazaoSocial = this.idData.name;
    obj.nuInscricao = this.idData.sub;
    obj.tpContribuinte = this.empresaList.length > 0 ? 1 : 2;
    obj.tpInscricao = 1;
    obj.stAtivo = true;
    this.service
      .create(obj)
      .then((res: any) => {
        this.loginService.salvarDadosLoginUnico({
          dadosLoginUnico: this.data.dadosLoginUnico,
          contribuinte: res.result,
        });
        const callbackState = this.getCookie("callbackLoginUnico") || {};
        let codAudienciaPublica: any =
          sessionStorage.getItem("codAudienciaPublica") ||
          callbackState?.codAudienciaPublica ||
          this.data?.codAudienciaPublica;

        if (codAudienciaPublica) {
          sessionStorage.setItem("codAudienciaPublica", String(codAudienciaPublica));
          this.setCookie("callbackLoginUnico", {}, 1);
          sessionStorage.removeItem("dispositivoId");
          sessionStorage.removeItem("tokenInvite");
          this.history.replace(`/eventos?CodigoAudiencia=${codAudienciaPublica}`);
        } else {
          this.history.replace("/home");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => this.stop());
  }

  public validaSalvar() {
    let valid = this.validaCampo(this.model.cdUf, this.model.setUfValid);
    valid =
      this.validaCampo(this.model.cdMunicipio, this.model.setMunicipioValid) &&
      valid;
    valid =
      this.validaCampo(
        this.model.cdTipoInteressado,
        this.model.setTipoInteressadoValid
      ) && valid;
    return valid;
  }

  private obterTipoInteressado(dadosLoginUnico: any) {
    this.start();
    this.service
      .obterTipoInteressado(dadosLoginUnico.empresaList.length > 0 ? 1 : 2)
      .then((res: any) => {
        this.setTipoInteressadoList(res.result);
      })
      .catch((err) => console.log(err))
      .finally(() => this.stop());
  }

  private obterAreaInteresse() {
    this.start();
    this.service
      .obterAreaInteresse()
      .then((res: any) => {
        this.setAreaInteresseList(res.result);
      })
      .catch((err) => console.log(err))
      .finally(() => this.stop());
  }

  private obterUf() {
    this.start();
    this.service
      .obterUf()
      .then((res: any) => {
        const lista = res.result;
        lista.forEach(
          (f: any) => (f.nomeUF = f.nomeUF + " - " + f.descricaoSigla)
        );
        this.setUfList(lista);
      })
      .catch((err) => console.log(err))
      .finally(() => this.stop());
  }

  public obterMunicipio(cdUf: any) {
    if (!cdUf) {
      this.setMunicipioList([]);
      this.model.setCdUf("");
      this.model.setCdMunicipio("");
      return;
    }
    this.start();
    this.service
      .obterMunicipio(cdUf)
      .then((res: any) => {
        this.setMunicipioList(res.result);
      })
      .catch((err) => console.log(err))
      .finally(() => this.stop());
  }

  public checkAreaInteresse(value: any) {
    const isPresent =
      this.model.rlContribuinteAreaInteresse.filter(
        (f: any) => f.cdAreaInteresse === value
      ).length > 0;
    if (isPresent) {
      this.model.setRlContribuinteAreaInteresse([
        ...this.model.rlContribuinteAreaInteresse.filter(
          (f: any) => f.cdAreaInteresse !== value
        ),
      ]);
      return;
    }
    this.model.setRlContribuinteAreaInteresse([
      ...this.model.rlContribuinteAreaInteresse,
      { cdAreaInteresse: value },
    ]);
  }

  public isCheckAreaInteresse(value: any) {
    return (
      this.model.rlContribuinteAreaInteresse.filter(
        (f: any) => f.cdAreaInteresse === value
      ).length > 0
    );
  }
}
